import styled from "styled-components";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px;
  padding-bottom: 40px;
  background-color: #202020;
`;

export const Title = styled.h2`
  font-size: 32px;
  color: white;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 28px;
    padding: 20px;
    padding-bottom: 40px;
  }
`;

export const SubTitleDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 815px;
`;

export const SubTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #6c04ba;
  color: #ffffff;
  font-size: 22px;
  height: 65px;
  margin-top: ${({ $hiddenSubtitle }) => $hiddenSubtitle && "60px"};
  margin-top: 60px;
`;

export const Bold = styled.span`
  font-weight: bold;
  margin-right: 5px;
`;

export const ImgIngresso = styled.img`
  width: 110px;
  height: 27px;
  margin: 0 10px;
`;

export const BenefitsDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: #ffffff;
  margin-top: 25px;
`;

export const Benefits = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

export const Benefit = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const ImgBenefit = styled.img`
  width: 40px;
  height: 40px;
  margin: 0 10px;
`;

export const TextBenefit = styled.p`
  font-size: 16px;
  margin-top: 10px;
`;

export const PlansContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  min-height: 480px;
  margin: 80px auto 0;
  background-color: #202020;
  color: white;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 10px;
`;

export const Tab = styled.div`
  flex: 1;
  width: 250px;
  height: ${(props) => (props.$active ? "130px" : "120px")};
  margin-bottom: ${(props) => (props.$active ? "0" : "10px")};
  padding: 20px;
  text-align: center;
  background-color: ${(props) => (props.$active ? "#393939" : "#292929")};
  color: ${(props) => (props.$active ? "white" : "#727272")};
  font-weight: ${(props) => (props.$active ? "bold" : "regular")};
  font-size: 20px;
  text-align: left;
  line-height: 1.1;
  border: 2px solid
    ${(props) => (props.$active ? props.$borderColor : "transparent")};
  border-bottom: ${(props) => (props.$active ? "none" : "2px solid #393939")};
  z-index: 1;
  position: relative;

  &:hover {
    cursor: pointer;
    border: 2px solid ${(props) => props.$borderColor};
    border-bottom: 2px solid
      ${(props) => (props.$active ? "transparent" : props.$borderColor)};
    z-index: 1;
  }
`;

export const TabInfo = styled.div`
  font-size: 16px;
  color: #727272;
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  bottom: 10px;
  left: 20px;
  right: 20px;

  p {
    font-size: 20px;
    font-weight: bold;
    margin-left: 5px;
    margin-bottom: 7px;
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  width: 1199px;
  background-color: #393939;
  padding: 17px;
  border: 2px solid ${(props) => props.$borderColor || "transparent"};
  margin-top: -2px;
`;

export const PriceBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #222222;
  gap: 8px;
  width: 443px;
  height: 373px;
  padding: 12px;
`;

export const PlanCard = styled.div`
  border: 2px solid
    ${({ $borderColor, $isSelected }) =>
      $isSelected ? $borderColor : "transparent"};
  border-radius: 4px;
  display: flex;
  width: 418px;
  height: 155px;
  flex-direction: row;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.3s;
`;

export const AnnualPrice = styled(PlanCard)`
  position: relative;
`;

export const MonthlyPrice = styled(PlanCard)`
  justify-content: space-around;
  align-items: center;
`;

export const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const DivRadio = styled(Div)``;

export const DivPrice = styled(Div)`
  height: 108px;
  margin-top: ${({ hiddenReceba40 }) => (hiddenReceba40 ? "21px" : "-10px")};
  margin-left: 40px;
`;

export const Discount = styled.div`
  background-color: ${({ $isSelected, $borderColor }) =>
    $isSelected ? $borderColor : "#1D1D1D"};
  width: 188px;
  color: ${({ $isSelected }) => ($isSelected ? "#ffffff" : "#727272")};
  padding: 5px 10px 5px 23px;
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0;
  border-radius: 0 20px 20px 0;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;

  ${AnnualPrice} & {
    margin-bottom: 50px;
  }

  input {
    cursor: pointer;
    appearance: none;
    border: 3px solid #808080;
    border-radius: 50%;
    outline: none;
    width: 21px;
    height: 21px;
    display: flex;
    align-items: center;
    position: relative;

    &:checked {
      border-color: ${({ $isSelected }) =>
        $isSelected ? "#ff8000" : "#727272"};
    }

    &:checked::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 11px;
      height: 11px;
      background-color: ${({ $isSelected }) =>
        $isSelected ? "#ff8000" : "#727272"};
      border-radius: 50%;
    }
  }

  label {
    color: ${({ $isSelected }) => ($isSelected ? "#ffffff" : "#727272")};
    cursor: pointer;
    font-size: 16px;
    padding-top: 10px;
    display: flex;
    align-items: center;
  }
`;

export const CinemaOffer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 50%;
  background-color: ${({ $isSelected }) =>
    $isSelected ? "#6C04BA" : "#1D1D1D"};
  font-size: 18px;
  color: ${({ $isSelected }) => ($isSelected ? "#ffffff" : "#727272")};
  padding: 4px 40px 2px 20px;
  margin: 13px 0;
  border-radius: 20px 0 0 20px;

  p {
    font-size: 18px;
  }
`;

export const Price = styled.div`
  font-size: 16px;

  span {
    font-size: 24px;
    font-weight: bold;
  }

  color: ${({ $isSelected }) => ($isSelected ? "#ffffff" : "#727272")};
`;

export const TotalPrice = styled.div`
  font-size: 14px;
  color: #999;
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ $uniqueOption }) => $uniqueOption ? "0" : "32px"};

  h4 {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: ${({ $uniqueOption }) => $uniqueOption ? "24px" : "32px"};
  }

  p {
    font-size: 18px;
    margin-bottom: ${({ $uniqueOption }) => $uniqueOption ? "0" : "18px"};
    color: white;
    text-align: center;
    padding: 16px 24px 0 24px;
    padding-top: ${({ $uniqueOption }) => $uniqueOption && "24px"};
  }
`;

export const Logos = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  padding: ${({ $uniqueOption }) => $uniqueOption && "24px 18px 0"};

  img {
    max-width: 100%;
    height: auto;
  }
`;
